import { register } from "@rill/loader";

register(
  {
    name: "coachEditorNotes",
    meta: ["no-bust", "client-notes"],
    ttl: "2 hours",
  },
  async ({ api }, { proxyAthlete }) => {
    const query = {
      proxyAthlete,
    };

    const res = await api("client-notes", { query });
    const resJson = await res.json();

    return resJson;
  }
);
